import GraphemeSplitter from 'grapheme-splitter';

const splitString = (text: string): string[] => {
  const splitter = new GraphemeSplitter();
  return splitter.splitGraphemes(text);
};

const countString = (text: string): number => {
  if (!text?.length) return 0;
  return splitString(text).length;
};

const sliceString = (s: string, start: number, end?: number): string => {
  return splitString(s).slice(start, end).join('');
};

const countCharactersExcludeNewlines = (value: string): number => countString(value?.replaceAll(/\n/g, ''));

export { countString, countCharactersExcludeNewlines, sliceString };
